import React from 'react';
import AIPreferenceChat from '../AIPreferenceChat';

function AIChatModal({
  show,
  onClose,
  studentProfile,
  schoolCounts,
  recommendations,
  onFilterApplied,
  reportUuid,
  onProfileUpdated
}) {
  if (!show) return null;

  return (
    <div className="ai-chat-modal-overlay" onClick={onClose}>
      <div className="ai-chat-modal" onClick={(e) => e.stopPropagation()}>
        <div className="ai-chat-modal-header">
          <h2>AI College Advisor</h2>
          <button
            className="modal-close-btn"
            onClick={onClose}
            aria-label="Close AI Chat"
          >
            ✕
          </button>
        </div>
        <div className="ai-chat-modal-content">
          <AIPreferenceChat
            studentProfile={studentProfile}
            schoolCounts={schoolCounts}
            initialRecommendations={recommendations}
            onFilterApplied={onFilterApplied}
            reportUuid={reportUuid}
            onProfileUpdated={onProfileUpdated}
          />
        </div>
      </div>
    </div>
  );
}

export default AIChatModal;